import { Component, inject } from "@angular/core";
import { AuthService } from "@shared/auth";

@Component({
    selector: "wk-all-view-container",
    templateUrl: "./all-view-container.component.html",
    standalone: false,
})
export class AllViewContainerComponent {
    protected readonly authService = inject(AuthService);
}
